<template>
  <div
    v-if="deliveryOptionsFiltered && deliveryOptionsFiltered.length"
    class="calculator__items"
  >
    <div class="calculator__item calculator__item_active">
      <div class="calculator__item-content">
        <div class="calculator-options calculator-options_delivery calculator-options_next">
          <div class="calculator-options__info">
            <div class="calculator-field__label">
              {{ $t('calc.label.type_delivery') }}
            </div>

            <ul class="calculator-options__items">
              <template
                v-for="option in deliveryOptionsFiltered"
              >
                <div
                  :key="option.delivery_type"
                  class="calc-radio-wrap"
                >
                  <div
                    class="calc-radio-btn"
                    :class="{ 'active': option.delivery_type === orderPIP.delivery_type }"
                    @click="orderPIP.delivery_type = option.delivery_type"
                  >
                    <svg
                      v-if="option.delivery_type === orderPIP.delivery_type"
                      class="calc-radio-btn__icon"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#select-on" />
                    </svg>
                    <svg
                      v-else
                      class="calc-radio-btn__icon"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#select-off" />
                    </svg>
                    <div
                      class="calc-radio-btn__name"
                      v-html="deliveryName(option.delivery_type)"
                    />
                    <div class="calc-radio-btn__size d-flex align-items-center">
                      <span
                        v-if="option.time"
                        class="calc-radio-btn__days"
                      >
                        {{ option.time }}&nbsp; {{
                          num2str(option.time, [' рабочий', ' рабочих', ' рабочих'])
                        }} {{ num2str(option.time, [' день', ' дня', ' дней']) }}
                      </span>
                      <span
                        v-else
                        class="calc-radio-btn__days"
                      >
                        -/- рабочих дней
                      </span>
                      <span
                        v-if="!option.checkIndex || (option.showPrice && !option.showAddressForm)"
                        class="calculator-options__cost"
                        :class="{ 'calculator-options__cost_list' : option.checkIndex}"
                      >
                        {{ getPrice(option.cost) }}
                        <svg
                          v-if="!isDirectionKzKz"
                          width="16px"
                          height="16px"
                        >
                          <use xlink:href="#rouble" />
                        </svg>
                        <svg
                          v-else
                          width="16"
                          height="16"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M5.33594 3.5H18.6329V4.99925H5.33594V3.5ZM12.7651 21.3215H11.2351V7.99774H5.33594V6.49849H18.6329V7.99774H12.7651V21.3215Z"
                            fill="#50616F"
                          />
                        </svg>
                      </span>
                      <span
                        v-else
                        class="calculator-options__cost"
                      >
                        -
                        <svg
                          v-if="!isDirectionKzKz"
                          width="16px"
                          height="16px"
                        >
                          <use xlink:href="#rouble" />
                        </svg>
                        <svg
                          v-else
                          width="16"
                          height="16"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <path
                            d="M5.33594 3.5H18.6329V4.99925H5.33594V3.5ZM12.7651 21.3215H11.2351V7.99774H5.33594V6.49849H18.6329V7.99774H12.7651V21.3215Z"
                            fill="#50616F"
                          />
                        </svg>
                      </span>
                    </div>
                    <div class="calc-radio-btn__desc">
                      <button
                        v-if="showLinkEdit(option)"
                        class="calc-radio-btn__link"
                        type="button"
                        @click="() => onLinkClick(option)"
                      >
                        Редактировать адрес
                      </button>
                      <template v-else-if="option.delivery_type === 3">
                        Для расчета курьерской доставки необходимо уточнить адрес
                      </template>
                      <template v-else-if="option.delivery_type === 2">
                        Для расчета курьерского забора необходимо уточнить адрес
                      </template>
                      <template v-else-if="option.delivery_type === 1">
                        Для расчета курьерской доставки и забора необходимо уточнить адрес
                      </template>
                      <template v-else>
                        Срок доставки указан без учета дня приема отправления
                      </template>
                    </div>
                  </div>
                </div>
                <CalculatorFormAddress
                  v-if="isMobile"
                  v-show="option.checkIndex && option.showAddressForm"
                  :key="`mobile${option.delivery_type}`"
                  :option="option"
                  :order-calc-p-i-p="orderCalcPIP"
                  :error-dictionary="errorDictionary"
                  :address-default-sender="addressDefaultSender"
                  :address-default-receiver="addressDefaultReceiver"
                  :sale-pip="salePip"
                  :calc-import="calcImport"
                  @addressHomeSenderChanged="option.sender.addressHome = $event"
                  @addressStreetSenderChanged="option.sender.addressStreet = $event"
                  @addressZipSenderChanged="option.sender.addressZip = $event"
                  @changeZipSenderError="option.sender.zipError = $event"
                  @addressAllSenderChanged="option.sender.addressAll = $event"
                  @addressHomeReceiverChanged="option.receiver.addressHome = $event"
                  @addressStreetReceiverChanged="option.receiver.addressStreet = $event"
                  @addressZipReceiverChanged="option.receiver.addressZip = $event"
                  @changeZipReceiverError="option.receiver.zipError = $event"
                  @addressAllReceiverChanged="option.receiver.addressAll = $event"

                  @changeZipSuccess="changeZipSuccess($event, option)"
                  @updateDataByType="updateDataByType"
                  @changeShowPrice="changeShowPrice($event, option)"
                  @closeForm="option.showAddressForm = false"

                  @changeDefaultAddressSender="addressDefaultSender = $event"
                  @changeDefaultAddressReceiver="addressDefaultReceiver = $event"
                />
              </template>
              <template
                v-for="option in deliveryOptionsFiltered"
              >
                <CalculatorFormAddress
                  v-if="!isMobile"
                  v-show="option.checkIndex && option.showAddressForm"
                  :key="`desktop${option.delivery_type}`"
                  :option="option"
                  :order-calc-p-i-p="orderCalcPIP"
                  :error-dictionary="errorDictionary"
                  :address-default-sender="addressDefaultSender"
                  :address-default-receiver="addressDefaultReceiver"
                  :sale-pip="salePip"
                  :calc-import="calcImport"
                  @addressHomeSenderChanged="option.sender.addressHome = $event"
                  @addressStreetSenderChanged="option.sender.addressStreet = $event"
                  @addressZipSenderChanged="option.sender.addressZip = $event"
                  @changeZipSenderError="option.sender.zipError = $event"
                  @addressAllSenderChanged="option.sender.addressAll = $event"
                  @addressHomeReceiverChanged="option.receiver.addressHome = $event"
                  @addressStreetReceiverChanged="option.receiver.addressStreet = $event"
                  @addressZipReceiverChanged="option.receiver.addressZip = $event"
                  @changeZipReceiverError="option.receiver.zipError = $event"
                  @addressAllReceiverChanged="option.receiver.addressAll = $event"

                  @changeZipSuccess="changeZipSuccess($event, option)"
                  @updateDataByType="updateDataByType"
                  @changeShowPrice="changeShowPrice($event, option)"
                  @closeForm="option.showAddressForm = false"

                  @changeDefaultAddressSender="addressDefaultSender = $event"
                  @changeDefaultAddressReceiver="addressDefaultReceiver = $event"
                />
              </template>
            </ul>
            <div
              v-if="orderPIP.sender.country === COUNTRY_CODES.RUSSIA || calcImport"
              class="accordion accordion_calc"
            >
              <div class="accordion__items">
                <div
                  v-if="!hidePromocodeOption"
                  class="accordion__item"
                  :class="{'accordion__item_active': showPromocodeInput}"
                >
                  <p
                    class="accordion__title"
                    @click="() => { showPromocodeInput = !showPromocodeInput }"
                  >
                    <span class="calculator-field__label">{{ $t('promocode') }}</span>
                    <svg
                      class="ms-auto"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#arrow-down" />
                    </svg>
                  </p>
                  <div class="calculator__promocode-content accordion__inner">
                    <div class="calculator__promocode-input">
                      <div
                        class="field-input"
                        :class="{
                          'calc__input-error': promocodeApplied && !checkDeliveryMethod.discount,
                          'field-full': orderCalcPIP.promo_code && orderCalcPIP.promo_code.length
                        }"
                      >
                        <label>
                          <span class="label-description">Промокод</span>
                          <input
                            id="promocode"
                            v-model="orderCalcPIP.promo_code"
                            class="field-input__inner"
                            :placeholder="placeholderPromocode"
                            :readonly="promocodeSubmitted"
                            type="text"
                            autocomplete="new-password"
                            @input="() => { promocodeSubmitted = false }"
                          >
                        </label>
                        <svg
                          v-if="promocodeApplied && checkDeliveryMethod.discount"
                          class="calc__field-icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9.75 18.0019L3 11.2519L4.0605 10.1914L9.75 15.8802L19.9395 5.69141L21 6.75191L9.75 18.0019Z"
                            fill="#A6CE39"
                          />
                        </svg>
                        <svg
                          v-if="promocodeApplied && !checkDeliveryMethod.discount"
                          class="calc__field-icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 1.5C9.9233 1.5 7.89323 2.11581 6.16652 3.26957C4.4398 4.42332 3.09399 6.0632 2.29927 7.98182C1.50455 9.90045 1.29661 12.0116 1.70176 14.0484C2.1069 16.0852 3.10693 17.9562 4.57538 19.4246C6.04383 20.8931 7.91476 21.8931 9.95156 22.2982C11.9884 22.7034 14.0996 22.4955 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335C21.8842 16.1068 22.5 14.0767 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM12 21C10.22 21 8.47992 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89471 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17293C11.99 2.82567 13.7996 3.0039 15.4442 3.68508C17.0887 4.36627 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21Z"
                            fill="#ED1651"
                          />
                          <path
                            d="M11.25 6H12.75V14.25H11.25V6ZM12 16.5C11.7775 16.5 11.56 16.566 11.375 16.6896C11.19 16.8132 11.0458 16.9889 10.9606 17.1945C10.8755 17.4 10.8532 17.6262 10.8966 17.8445C10.94 18.0627 11.0472 18.2632 11.2045 18.4205C11.3618 18.5778 11.5623 18.685 11.7805 18.7284C11.9988 18.7718 12.225 18.7495 12.4305 18.6644C12.6361 18.5792 12.8118 18.435 12.9354 18.25C13.059 18.065 13.125 17.8475 13.125 17.625C13.125 17.3266 13.0065 17.0405 12.7955 16.8295C12.5845 16.6185 12.2984 16.5 12 16.5Z"
                            fill="#ED1651"
                          />
                        </svg>
                        <div
                          v-if="promocodeApplied && !checkDeliveryMethod.discount"
                          class="calc__field-error"
                        >
                          Промокода не существует
                        </div>
                      </div>
                    </div>
                    <a
                      v-if="!promocodeApplied"
                      class="calculator__promocode-btn btn-text ms-auto"
                      :disabled="isLoadingPromocode"
                      @click.prevent="onApplyPromocodeClick"
                    >
                      <span>{{ isLoadingPromocode ? 'Загрузка': 'Применить' }}</span>
                    </a>
                    <a
                      v-if="promocodeApplied"
                      class="calculator__promocode-btn btn-text ms-auto"
                      :disabled="isLoadingPromocode"
                      @click.prevent="onResetPromocodeClick"
                    >
                      <span>{{ isLoadingPromocode ? 'Загрузка': 'Отменить' }}</span>
                    </a>
                  </div>
                </div>

                <div
                  v-if="listServices.length"
                  class="accordion__item"
                  :class="{'accordion__item_active': showOptions}"
                >
                  <p
                    class="accordion__title"
                    @click="() => { showOptions = !showOptions }"
                  >
                    <span class="calculator-field__label">Дополнительные услуги</span>
                    <svg
                      class="ms-auto"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#arrow-down" />
                    </svg>
                  </p>
                  <div class="calculator__promocode-content accordion__inner">
                    <div class="calculator-options">
                      <div class="calculator-options__info">
                        <ul
                          v-if="listServices.length && canUsedServices.length"
                          class="calculator-options__items"
                        >
                          <li
                            v-for="(service) in canUsedServices"
                            :key="service.ID"
                            class="calculator__checkbox"
                          >
                            <span class="field-checkbox">
                              <input
                                :id="service.ID"
                                v-model="orderCalcPIP.list_services"
                                class="field-checkbox__input"
                                type="checkbox"
                                name="list_services"
                                :value="service.ID"
                              >
                              <label
                                class="field-checkbox__label services-name"
                                :for="service.ID"
                              >
                                {{ service.name.replace(new RegExp('\\(?ПиП\\)?', 'ig'), '') }}&nbsp;<span
                                  class="services-count"
                                >+&nbsp;{{ service.price / 100 }}&nbsp;<i class="ruble">O</i></span>
                              </label>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <CalculatorServicesOptions
                  v-if="!hideServices && listDeliveryService"
                  :delivery-services-list="listDeliveryService.services"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global ym, $ */
import deviceInfo from '../../helpers/device';
import * as odpRepository from '../../store/odp.repository';
import num2str from '../../helpers/num2str';
import calculate from '../../models/calculator-pip';
import { COUNTRY_CODES, DELIVERY_TYPES, REGION_NAME } from '../../helpers/constans';
import CalculatorFormAddress from './CalculatorFormAddress.vue';
import CalculatorServicesOptions from './CalculatorServicesOptions.vue';
import currencyConversion from '../../helpers/payment';
import UTMTags from '../../mixins/UTMTags';

export default {
  name: 'CalculatorPIP2ndStepView',
  components: { CalculatorServicesOptions, CalculatorFormAddress },
  mixins: [UTMTags],
  props: ['orderPIP', 'orderCalcPIP', 'kladr', 'initialDeliveryOptions', 'listServices', 'isValid', 'validations',
    'errorDictionary', 'salePip', 'hidePromocodeOption', 'calcImport', 'cbrDaily', 'hideServices', 'isCustoms', 'isDirectionKzKz'],
  data() {
    return {
      num2str,
      showOptions: false,
      showPromocodeInput: false,
      promocodeSubmitted: false,
      senderPointsCollection: null,
      receiverPointsCollection: null,
      placeholderPromocode: $(window).width() > 787 ? 'Введите промокод, если он у вас есть' : this.$t('calc.placeholder_promocode'),
      isLoading: false,
      isLoadingPromocode: false,
      delivery_options: [],
      addressDefaultSender: {},
      addressDefaultReceiver: {},
    };
  },
  computed: {
    ...deviceInfo,
    checkDeliveryMethod() {
      const listDeliveryService = this.delivery_options.filter((delivery) => delivery.delivery_type === this.orderPIP.delivery_type);
      if (listDeliveryService[listDeliveryService.length - 1] && listDeliveryService[listDeliveryService.length - 1].showPrice) {
        return listDeliveryService[listDeliveryService.length - 1];
      }
      return [];
    },
    listDeliveryService() {
      const listDeliveryService = this.delivery_options.find((delivery) => delivery.delivery_type === DELIVERY_TYPES.PVZ_TO_PVZ);
      if (listDeliveryService) return listDeliveryService;

      return this.checkDeliveryMethod;
    },
    totalPrice() {
      if (this.checkDeliveryMethod && this.checkDeliveryMethod.cost) {
        return (parseInt(this.checkDeliveryMethod.cost, 10) / 100).toFixed(2);
      }
      return '';
    },

    srcImg() {
      // eslint-disable-next-line
      return urlPrefix ? 'https://storage.yandexcloud.net/boxberrysite-public/calculator_pip/clock.png'
        : '/packages/boxberry/theme/frontend/build/static/img/assets/statistic/clock.svg';
    },
    canUsedServices() {
      return this.listServices.filter((service) => service.canBeSelect === '1');
    },
    orderNoKZ() {
      return [REGION_NAME.MOSCOW, REGION_NAME.MOSCOW_OBLAST, REGION_NAME.SAINT_PETERSBURG, REGION_NAME.LENINGRAD_OBLAST]
        .includes(this.orderCalcPIP.sender.region);
    },
    orderImport() {
      return [COUNTRY_CODES.KYRGYZSTAN, COUNTRY_CODES.KAZAKHSTAN, COUNTRY_CODES.BELARUS, COUNTRY_CODES.ARMENIA].includes(this.orderCalcPIP.sender.country);
    },
    deliveryOptionsFiltered() {
      if (this.orderImport) {
        return this.delivery_options.filter((options) => [DELIVERY_TYPES.PVZ_TO_PVZ].includes(options.delivery_type));
      }
      if (this.orderNoKZ) {
        return this.delivery_options
          .filter((options) => [DELIVERY_TYPES.PVZ_TO_PVZ, DELIVERY_TYPES.PVZ_TO_DOOR].includes(options.delivery_type));
      }
      return this.delivery_options;
    },
    cbrDailySelected() {
      return this.cbrDaily.find((item) => item.numeric_code === this.orderPIP.sender.country);
    },
    totalPriceImport() {
      if (!this.totalPrice || !this.cbrDailySelected || !Object.keys(this.cbrDailySelected).length) return '';
      return currencyConversion(this.totalPrice, this.cbrDailySelected.quantity, this.cbrDailySelected.exchange_rate);
    },
    currencyName() {
      if (!this.totalPrice || !this.cbrDailySelected || !Object.keys(this.cbrDailySelected).length) return '';
      return this.cbrDailySelected.symbol_code;
    },
    promocodeApplied() {
      return this.orderCalcPIP.promo_code && this.orderCalcPIP.promo_code.length && this.promocodeSubmitted;
    },
  },
  watch: {
    totalPrice(val) {
      this.$emit('changeTotalPrice', val);
    },
    initialDeliveryOptions: {
      handler(val) {
        if (val) {
          this.delivery_options = JSON.parse(JSON.stringify(val));
        }
      },
      deep: true,
      immediate: true,
    },
    'orderPIP.delivery_type': function (val) {
      this.delivery_options = this.delivery_options.map((delivery) => {
        const showAddressForm = delivery.delivery_type === val && (!delivery.zipSuccess || delivery.showAddressForm);

        return ({ ...delivery, showAddressForm });
      });
    },
    'orderCalcPIP.sender.city': function () {
      this.addressDefaultSender = {};
      if (this.deliveryOptionsFiltered[0]) {
        this.orderPIP.delivery_type = this.deliveryOptionsFiltered[0].delivery_type;
      }
    },
    'orderCalcPIP.receiver.city': function () {
      this.addressDefaultReceiver = {};
      if (this.deliveryOptionsFiltered[0]) {
        this.orderPIP.delivery_type = this.deliveryOptionsFiltered[0].delivery_type;
      }
    },
    checkDeliveryMethod: {
      handler(val) {
        this.$emit('changeCheckDeliveryMethod', val);
      },
      deep: true,
      immediate: true,
    },
    'orderCalcPIP.forcePromocode': function (val) {
      if (val) {
        this.onApplyPromocodeClick('force');
      }
    },
    promocodeSubmitted(val) {
      this.$emit('changePromocodeSubmitted', val);
    },
    totalPriceImport(val) {
      this.$emit('changeTotalPriceImport', val);
    },
  },
  created() {
    // установим значение по умолчанию.
    this.orderPIP.delivery_type = DELIVERY_TYPES.PVZ_TO_PVZ;
    this.COUNTRY_CODES = COUNTRY_CODES;
  },
  mounted() {
    if (this.orderCalcPIP.promo_code) {
      this.promocodeSubmitted = true;
    }
  },
  methods: {
    stepBack() {
      this.$emit('step-back');
    },
    saveAddress() {
      const delivery = this.deliveryOptionsFiltered.find((item) => item.delivery_type === this.orderPIP.delivery_type);
      this.orderPIP.receiver.addressHome = delivery.receiver.addressHome;
      this.orderPIP.receiver.addressStreet = delivery.receiver.addressStreet;
      this.orderPIP.receiver.zip = delivery.receiver.addressZip;
      this.orderPIP.receiver.address = delivery.receiver.addressAll;

      this.orderPIP.sender.addressHome = delivery.sender.addressHome;
      this.orderPIP.sender.addressStreet = delivery.sender.addressStreet;
      this.orderPIP.sender.zip = delivery.sender.addressZip;
      this.orderPIP.sender.address = delivery.sender.addressAll;
    },
    secondCalcStepHandlerPIP() {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'calc_2step_button');
      }

      const self = this;

      this.isLoading = true;
      this.saveAddress();

      const fromPoints = odpRepository.default.findInCity(this.orderCalcPIP.sender.city, '10000', ['receptionLap'])
        .then((odp) => {
          self.senderPointsCollection = odp.data.odp;
        });

      const toPoints = odpRepository.default.findInCity(this.orderCalcPIP.receiver.city, '10000', ['deliveryLap'])
        .then((odp) => {
          self.receiverPointsCollection = odp.data.odp;
        });

      Promise.all([fromPoints, toPoints])
        .finally(() => {
          this.isLoading = false;
          this.$emit('step-up', {
            senderPointsCollection: this.senderPointsCollection,
            receiverPointsCollection: this.receiverPointsCollection,
          });
        });
    },
    deliveryName(deliveryType) {
      let name;

      switch (deliveryType) {
        case DELIVERY_TYPES.DOOR_TO_DOOR:
          name = 'От двери до&nbsp;двери';
          break;
        case DELIVERY_TYPES.DOOR_TO_PVZ:
          name = 'От двери до&nbsp;отделения';
          break;
        case DELIVERY_TYPES.PVZ_TO_DOOR:
          name = 'От отделения до&nbsp;двери';
          break;
        case DELIVERY_TYPES.PVZ_TO_PVZ:
          name = this.$t('calc.delivery_types.pvz_pvz');
          break;
        default:
          throw new Error(`Неизвестный способ доставки #${deliveryType}`);
      }

      return name;
    },
    onApplyPromocodeClick(force) {
      if (!this.orderCalcPIP.promo_code) {
        return;
      }
      this.isLoadingPromocode = true;
      if (force !== 'force') {
        this.orderCalcPIP.forcePromocode = '';
      }
      calculate(this.orderCalcPIP, this.errorDictionary, this.$props.salePip, this.$props.calcImport)
        .then((deliveryOptions) => {
          this.updateData(deliveryOptions);
          this.promocodeSubmitted = true;
          if (!this.orderCalcPIP.forcePromocode) {
            this.orderPIP.promocode = this.orderCalcPIP.promocode;
          }
        })
        .catch((errArr) => {
          if (errArr.message) {
            this.$emit('error', errArr.message);
          }
          if (Array.isArray(errArr)) {
            this.$emit('error', errArr);
          }
        })
        .finally(() => {
          this.isLoadingPromocode = false;
        });
    },
    updateData(deliveryOptions) {
      this.delivery_options = this.delivery_options.map((item, index) => ({
        ...deliveryOptions[index],
        checkIndex: item.checkIndex,
        showPrice: item.showPrice,
        showSender: item.showSender,
        showReceiver: item.showReceiver,
        showAddressForm: item.showAddressForm,
        zipSuccess: item.zipSuccess,
        sender: item.sender,
        receiver: item.receiver,
      }));
    },
    updateDataByType(deliveryOption) {
      this.delivery_options = this.delivery_options.map((delivery) => {
        if (delivery.delivery_type !== deliveryOption.delivery_type) return delivery;
        return ({
          ...delivery,
          ...deliveryOption,
        });
      });
    },
    getPrice(cost) {
      return (parseInt(cost, 10) / 100).toFixed(2);
    },
    onLinkClick(option) {
      this.delivery_options = this.delivery_options.map((delivery) => {
        const showAddressForm = delivery.delivery_type === option.delivery_type;
        return ({ ...delivery, showAddressForm });
      });
    },
    showLinkStart(option) {
      return option.checkIndex
        && (option.zipSuccess === null)
        && !option.showAddressForm;
    },
    showLinkEdit(option) {
      return option.checkIndex
        && (option.zipSuccess !== null)
        && !option.showAddressForm;
    },
    showCostError(option) {
      return ((option.showSender && option.sender.zipError) || (option.showReceiver && option.receiver.zipError))
        && !option.showAddressForm;
    },
    changeShowPrice($event, option) {
      this.delivery_options = this.delivery_options.map((delivery) => {
        if (delivery.delivery_type !== option.delivery_type) return delivery;
        return ({
          ...delivery,
          showPrice: $event,
        });
      });
    },
    changeZipSuccess($event, option) {
      this.delivery_options = this.delivery_options.map((delivery) => {
        if (delivery.delivery_type !== option.delivery_type) return delivery;
        return ({
          ...delivery,
          zipSuccess: $event,
        });
      });
    },
    onResetPromocodeClick() {
      this.isLoadingPromocode = true;
      this.orderCalcPIP.promo_code = '';
      this.promocodeSubmitted = false;
      calculate(this.orderCalcPIP, this.errorDictionary, this.$props.salePip, this.$props.calcImport)
        .then((deliveryOptions) => {
          this.updateData(deliveryOptions);
        })
        .catch((errArr) => {
          if (errArr.message) {
            this.$emit('error', errArr.message);
          }
          if (Array.isArray(errArr)) {
            this.$emit('error', errArr);
          }
        })
        .finally(() => {
          this.isLoadingPromocode = false;
        });
    },
  },
};
</script>
<style lang="scss">
.baseCount_kz-kz::after {
     background-image: url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='700' height='950'%3e%3cg id='layer1'%3e%3crect width='700' height='100' x='0' y='0' id='rect2852' style='fill:%23000000;fill-opacity:1;fill-rule:nonzero;stroke:none' /%3e%3cpath d='m 700,150 0,100 -300,0 0,700 -100,0 0,-700 -300,0 0,-100 700,0 z' id='path2854' style='stroke-width:1px' /%3e%3c/g%3e%3c/svg%3e") !important;
}
.calculator-total__cost_kz-kz {
  &::after {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='700' height='950'%3e%3cg id='layer1'%3e%3crect width='700' height='100' x='0' y='0' id='rect2852' style='fill:%23000000;fill-opacity:1;fill-rule:nonzero;stroke:none' /%3e%3cpath d='m 700,150 0,100 -300,0 0,700 -100,0 0,-700 -300,0 0,-100 700,0 z' id='path2854' style='stroke-width:1px' /%3e%3c/g%3e%3c/svg%3e");
  }
}
</style>

<style lang="scss" scoped>
.calc-radio-wrap {
  flex-grow: 1;
  svg {
    top: 21px;
  }
  .calc-radio-btn {
    flex-direction: column;
    flex-grow: 1;
    min-height: 104px;
    padding: 12px 16px;
  }
  .calc-radio-btn__size {
    margin-bottom: 1px;
  }
}
.calc-radio-btn__link {
  padding: 0;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  color: #50616F;
  border: none;
  border-bottom: 1px solid #50616F;
  outline: none;
  background-color: transparent;
  cursor: pointer;
}
.calc-radio-btn__desc {
  margin-top: auto;
}
.calculator__promocode-btn {
  display: flex;
  align-items: center;
  margin-left: 8px;
  width: 130px;
  height: 60px;
  flex-shrink: 0;
  @media (max-width: 1050px) {
    width: 82px;
  }
}
</style>
